import { call, put } from 'redux-saga/effects';

import { BadgeAPI } from 'services/badge.api';
import {
  badgeUserDetails,
  setBadgeUserDetailsStatus,
} from 'actions/badge.actions';
import { ActionType } from 'interfaces/actions.types';
import { LOADING_STATUS } from 'constants/status';

export function* getBadgeUserDetailsSaga({ payload }: ActionType): unknown {
  const { id } = payload;
  try {
    yield put(setBadgeUserDetailsStatus(id, LOADING_STATUS.PENDING));
    const { data } = yield call(BadgeAPI.getBadgeUserDetails, id);
    yield put(badgeUserDetails.success({ id, badge: data }));
    yield put(setBadgeUserDetailsStatus(id, LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(badgeUserDetails.failure({ id, error }));
    yield put(setBadgeUserDetailsStatus(id, LOADING_STATUS.REJECTED));
  }
}
